<template>
  <div class="py-4 pos-relative bg-dark3 text-white">
      <section class="secion-basic-i panel">
        <div class="guide-block">
          <div class="container">
            <div class="row">
              <div class="mt-5 guide-block01 col-md-6">
                <h1>{{ $t('landingHome_Music_distribution_for_everyone') }}</h1>
                <p class="block-desktop" v-html="$t('landingHome_No_more_worries')"></p>
                <p class="block-mobile" v-html="$t('landingHome_No_more_worries_mobile')"></p>
                <p class="block-mobile" v-html="$t('discover_our_ai_tools')"></p>
                <p class="block-desktop" v-html="$t('discover_our_ai_tools')"></p>
                <router-link :to="distributeNowLink" class="btn btn-lg btn-primary-new">{{ $t('start_now') }}</router-link>
              </div>
              <div class="mt-5 guide-block02 col-md-6 position-relative">
                <img src="/static/img/landing/distribution/Iphone13M-cropped.webp" alt="Indiefy Distribution Platform" class="img-fluid animated fadeInRight phone" id="phone">
                <img src="/static/img/landing/distribution/humo.webp" alt="humo" class="background" id="background">
                <div class="animated fadeIn animation-delay-400 title-idfy"><label></label>IDFY </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="text-center">
          <div class="container">
            <div class="text-45 mb-2">
              <span class="fw-extralight text-poppins">INDIEFY</span><span class="ml-3 bold-800 text-poppins">PRO</span>
            </div>
            <p class="pro-description" v-html="$t('indiefy_pro_benefits')"></p>
          </div>
        </div>
      </section>
      <div class="marquee-container mt-3">
        <div class="marquee-title bg-dark">
          Latest PRO
        </div>
        <marquee class="card-round bg-dark p-2 text-white">
          <div class="d-inline-block mr-4 ml-4" v-for="item in proArtists" v-bind:key="`top_${item._id}`">
            <div class="avatar pull-left">
              <img :src="item.cover_image_small || item.cover_image" alt="..." class="avatar-img rounded-circle">
            </div>
            <div class="info-post ml-2 pull-left">
              <a :href="`https://indiefy.me/${item.key}`" target="_blank" class="username">{{ item.name }}</a><br/>
              <div class="date text-muted"><img class="mr-1" width="16" onerror="this.src = '/static/img/img-placeholder-dark.jpg'" :src="`/static/img/countries/${item.user.country || 'default'}.png`"> {{ getCountryName(item.user.country) }}</div>
            </div>
          </div>
          <!-- <span v-for="item in proArtists" v-bind:key="`top_${item._id}`" class="mr-4">
            <a class="blue-text" target="_blank" :href="`https://indiefy.me/${item.key}`"><img class="mr-1" width="16" onerror="this.src = '/static/img/img-placeholder-dark.jpg'" :src="`/static/img/countries/${item.user.country || 'default'}.png`"> {{ item.name }}</a>
          </span> -->
        </marquee>
      </div>
      <div class="text-center container mt-3">
        <router-link to="/upgrade?from=landing-root" class="btn btn-gradient text-poppins tablet-centered">{{ $t('landingHome_Upgrade_to_pro') }}</router-link>
      </div>
      <section class="secion-basic-ii panel">
        <div class="guide-block05">
          <div class="container">
            <h3>YouTube Content ID</h3>
            <span v-html="$t('landingHome_yt_include_pro')"></span>
            <router-link to="/upgrade?from=landing-root" class="btn btn-primary-new-white">{{ $t('landingHome_Upgrade_to_pro') }}</router-link>
          </div>
        </div>
        <div class="guide-block07">
          <div class="text-center">
            <div class="container-min">
              <p v-html="$t('landingHome_Where_do_we')"></p>
              <h4>({{ $t('landingHome_Our_favorites') }} 🤫)</h4>
            </div>
            <VueSlickCarousel v-bind="settings">
              <div class="slick-item music-spotify">
                <div class="slick-img">
                  <img src="/static/img/landing/distribution/icons/spotify-icon.png" alt="Indiefy Distribution Platform" class="img-fluid">
                  <img src="/static/img/landing/distribution/icons/spotify-icon-green.png" alt="Indiefy Distribution Platform" class="img-fluid">
                </div>
                <div class="after">{{ $t('landingHome_Music_spotify') }}</div>
              </div>
              <div class="slick-item music-facebook">
                <div class="slick-img social-pro">
                  <img src="/static/img/landing/distribution/icons/facebook-icon.png" alt="Indiefy Distribution Platform" class="img-fluid">
                </div>
                <div class="after">{{ $t('landingHome_Music_facebook') }}</div>
              </div>
              <div class="slick-item music-deezer">
                <div class="slick-img">
                  <img src="/static/img/landing/distribution/icons/deezer-icon.png" alt="Indiefy Distribution Platform" class="img-fluid">
                  <img src="/static/img/landing/distribution/icons/deezer-icon-white.png" alt="Indiefy Distribution Platform" class="img-fluid">
                </div>
                <div class="after">{{ $t('landingHome_Music_deezer') }}</div>
              </div>
              <div class="slick-item music-TikTok">
                <div class="slick-img social-pro">
                  <img src="/static/img/landing/distribution/icons/TikTok-icon.png" alt="Indiefy Distribution Platform" class="img-fluid">
                </div>
                <div class="after">{{ $t('landingHome_Music_tiktok') }}</div>
              </div>
              <div class="slick-item music-youtube">
                <div class="slick-img">
                  <img src="/static/img/landing/distribution/icons/youtube-icon.png" alt="Indiefy Distribution Platform" class="img-fluid">
                </div>
                <div class="after">{{ $t('landingHome_Music_youtube') }}</div>
                </div>
              <div class="slick-item music-instagram">
                <div class="slick-img social-pro">
                  <img src="/static/img/landing/distribution/icons/instagram-icon.png" alt="Indiefy Distribution Platform" class="img-fluid">
                </div>
                <div class="after">{{ $t('landingHome_Music_intagram') }}</div>
              </div>
              <div class="slick-item music-apple">
                <div class="slick-img">
                  <img src="/static/img/landing/distribution/icons/apple_music_icon.png" alt="Indiefy Distribution Platform" class="img-fluid">
                </div>
                <div class="after">{{ $t('landingHome_Music_apple') }}</div>
              </div>
              <div class="slick-item music-amazon">
                <div class="slick-img social-pro">
                  <img src="/static/img/landing/distribution/icons/amazon-icon.png" alt="Indiefy Distribution Platform" class="img-fluid">
                </div>
                <div class="after">{{ $t('landingHome_Music_amazon') }}</div>
              </div>
            </VueSlickCarousel>
            <div class="container-min">
              <div class="music-know">
                <div class="music-row">
                  <div class="music-col-3 music-left music-spotify">
                    <img src="/static/img/landing/distribution/icons/spotify-icon.png" alt="Indiefy Distribution Platform" class="img-fluid">
                    <img src="/static/img/landing/distribution/icons/spotify-icon-green.png" alt="Indiefy Distribution Platform" class="img-fluid">
                    <div class="after">{{ $t('landingHome_Music_spotify') }}</div>
                  </div>
                  <div class="music-col-3 music-left music-facebook social-pro">
                    <img src="/static/img/landing/distribution/icons/facebook-icon.png" alt="Indiefy Distribution Platform" class="img-fluid">
                    <div class="after">{{ $t('landingHome_Music_facebook') }}</div>
                  </div>
                  <div class="music-col-3 music-right music-deezer">
                    <img src="/static/img/landing/distribution/icons/deezer-icon.png" alt="Indiefy Distribution Platform" class="img-fluid">
                    <img src="/static/img/landing/distribution/icons/deezer-icon-white.png" alt="Indiefy Distribution Platform" class="img-fluid">
                    <div class="after">{{ $t('landingHome_Music_deezer') }}</div>
                  </div>
                  <div class="music-col-3 music-right music-TikTok social-pro">
                    <img src="/static/img/landing/distribution/icons/TikTok-icon.png" alt="Indiefy Distribution Platform" class="img-fluid">
                    <div class="after">{{ $t('landingHome_Music_tiktok') }}</div>
                  </div>
                </div>
                <div class="music-row">
                  <div class="music-col-3 music-left music-youtube">
                    <img src="/static/img/landing/distribution/icons/youtube-icon.png" alt="Indiefy Distribution Platform" class="img-fluid">
                    <div class="after">{{ $t('landingHome_Music_youtube') }}</div>
                  </div>
                  <div class="music-col-3 music-left music-instagram social-pro">
                    <img src="/static/img/landing/distribution/icons/instagram-icon.png" alt="Indiefy Distribution Platform" class="img-fluid">
                    <div class="after">{{ $t('landingHome_Music_intagram') }}</div>
                  </div>
                  <div class="music-col-3 music-right music-apple">
                    <img src="/static/img/landing/distribution/icons/apple_music_icon.png" alt="Indiefy Distribution Platform" class="img-fluid">
                    <div class="after">{{ $t('landingHome_Music_apple') }}</div>
                  </div>
                  <div class="music-col-3 music-right music-amazon social-pro">
                    <img src="/static/img/landing/distribution/icons/amazon-icon.png" alt="Indiefy Distribution Platform" class="img-fluid">
                    <div class="after">{{ $t('landingHome_Music_amazon') }}</div>
                  </div>
                </div>
              </div>
              <h5 class="text-center"><a target="_blank" :href="linkStores">{{ $t('view_all_stores') }}</a></h5>
              <router-link :to="distributeNowLink" class="btn btn-lg btn-primary-new mt-4">{{ $t('landingHome_Send_my_music') }}</router-link>
            </div>
          </div>
        </div>
      </section>
      <section class="secion-basic-iii panel">
        <div class="container">
          <h2 class="text-center">{{ $t('landingHome_Options_for_all') }}</h2>
          <p class="text-center">{{ $t('landingHome_weve_got_options') }}</p>
          <div class="options-indiefy row">
            <div class="block-option block-pro col-md-6">
              <img src="/static/img/landing/distribution/logo-pro-new.png" alt="Indiefy Distribution Platform" class="img-fluid">
              <span class="title">PRO</span>
              <h3><b>$4.16<label style="color:#fff!important;font-size:22px!important;font-weight:400;"><span style="font-size:28px;">/</span>{{ $t('month') }}</label></b></h3>
              {{ $t('billed_yearly') }}
              <p v-html="$t('landingHome_Take_your_music')"></p>
              <ul>
                <li><i class="fas fa-check-circle"></i>{{ $t('landingHome_Fast_release_published') }}</li>
                <li><i class="fas fa-check-circle"></i>{{ $t('landingHome_Release_to_all27') }}</li>
                <li><i class="fas fa-check-circle"></i>{{ $t('pro_artists_or_bands') }}</li>
                <li><i class="fas fa-check-circle"></i>{{ $t('pro_releases_month') }}</li>
                <li><i class="fas fa-check-circle"></i>{{ $t('landingHome_Custom_label_name') }}</li>
                <li><i class="fas fa-check-circle"></i>{{ $t('landingHome_youtube_content_id') }}</li>
              </ul>
              <router-link :to="distributeNowLink" class="btn btn-primary-new">{{ $t('landingHome_Upgrade_to_pro') }}</router-link>
            </div>
            <div class="block-option block-free col-md-6">
              <img src="/static/img/landing/distribution/logo-pro-black.png" alt="Indiefy Distribution Platform" class="img-fluid">
              <span class="title">BASIC</span>
              <h3><b>{{ $t('landingHome_Basic') }}</b></h3>
              <p v-html="$t('landingHome_For_emerging_independent')"></p>
              <ul>
                <li><i class="fas fa-check-circle"></i> {{ $t('landingHome_Your_release_published') }}</li>
                <li><i class="fas fa-check-circle"></i> {{ $t('landingHome_Release_to_all') }}</li>
                <li><i class="fas fa-check-circle"></i> {{ $t('landingHome_Choose_release_date') }}</li>
                <li><i class="fas fa-check-circle"></i> {{ $t('landingHome_basic_support') }}</li>
              </ul>
              <router-link :to="distributeNowLink" class="btn btn-primary-new">{{ $t('landingHome_Sing_up_for_free') }}</router-link>
            </div>
          </div>
        </div>
      </section>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import Public from '../services/public'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import countries from '../data/countries'
import _ from 'underscore'

export default {
  name: 'LandingDistribution',
  components: { VueSlickCarousel },
  data: function () {
    return {
      proArtists: [],
      isMobileApp: navigator.userAgent.indexOf('gonative') >= 0,
      user: {},
      distributeNowLink: '/login',
      linkStores: 'https://help.indiefy.net/hc/en-us/articles/360045732514-Which-stores-does-Indiefy-distribute-to-',
      lang: 'en',
      words: [],
      locationSettings: {},
      currentWord: 0,
      hideEN: false,
      active01: 'active',
      active02: '',
      active03: '',
      settings: {
        'centerMode': true,
        'slidesToShow': 1,
        'slidesToScroll': 1,
        'variableWidth': true,
        'autoplay': true,
        'arrows': false,
        'dots': false,
        'infinite': true
      }
    }
  },
  methods: {
    getCountryName: function (userCountry) {
      const country = _.find(countries, item => item.code === userCountry)

      if (country) {
        return country.name
      }

      return 'N/A'
    },
    getLoginUrl: function (identifier) {
      let baseUrl = ''
      if (location.host.match(/free-music-distribution/)) {
        baseUrl = 'https://indiefy.net'
      }

      if (this.$user && this.$user._id) {
        return `${baseUrl}/dashboard`
      } else {
        if (navigator.userAgent.match(/bot|googlebot|prerender|crawler|spider|robot|crawling/i)) {
          return `${baseUrl}/login`
        }

        if (identifier) {
          return `${baseUrl}/login?from=${identifier}`
        }
        return `${baseUrl}/login`
      }
    },
    mouseOver: function (value) {
      if (value === 1) {
        this.active01 = 'active'
        this.active02 = ''
        this.active03 = ''
      } else if (value === 2) {
        this.active01 = ''
        this.active02 = 'active'
        this.active03 = ''
      } else if (value === 3) {
        this.active01 = ''
        this.active02 = ''
        this.active03 = 'active'
      }
    }
  },
  created: function () {
    this.basePath = `${location.protocol}//${location.host}${location.pathname}`
    this.isCrawler = navigator.userAgent.match(/bot|googlebot|prerender|crawler|spider|robot|crawling/i)
    this.user = this.$user

    window.document.title = this.$t('landing_title')
    window.$('meta[property="og:title"]').attr('content', this.$t('landing_title'))
    window.$('meta[name="description"]').attr('content', this.$t('landing_description'))
    window.$('meta[property="og:description"]').attr('content', this.$t('landing_description'))

    if (this.$route.query.utm_source) {
      localStorage.setItem('user_source', this.$route.query.utm_source)
      localStorage.setItem('user_medium', this.$route.query.utm_medium)
      localStorage.setItem('user_campaign', this.$route.query.utm_campaign)
    }

    if (this.$i18n) {
      this.lang = this.$i18n.locale
    }

    if (this.$route.query.lang) {
      this.lang = this.$route.query.lang
    }

    if (this.lang === 'es') {
      this.hideEN = true
    }

    if (this.isMobileApp) {
      if (this.user._id) {
        return this.$router.push(`/dashboard`)
      } else {
        return this.$router.push('/login')
      }
    }

    Public.getLocationSettings().then(response => {
      this.locationSettings = response.data

      if (this.$user._id) {
        this.distributeNowLink = '/dashboard'
      } else {
        this.distributeNowLink = '/login'
      }
    })

    Public.getPotentialArtists().then(response => {
      this.proArtists = response.data

      setTimeout(() => {
        window.prerenderReady = true
      }, 100)
    })
  },
  mounted: function () {
    window.$(window).scroll(function () {
      paralax()
    })
    paralax()
    function paralax () {
      var scrolled = window.$(window).scrollTop()
      if (window.$(window).width() > 768) {
        window.$('#phone').css('top', -(scrolled * 0.3) + 'px')
        let topCss = (scrolled * 0.3)
        topCss = topCss - 110
        window.$('#background').css('top', topCss + 'px')
      } else {
        window.$('#phone').removeAttr('style')
        window.$('#background').removeAttr('style')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.header-top {
  margin-bottom: 0;
  font-size: 2.5em;
}

.block-mobile{
  display: none;
}

.slick-slider{
  display: none !important;
  max-height: 606px;
  overflow: hidden;
}

.slick-item{
  width: 375px !important;
  height: 600px;
  margin: 0 10px;
}

.slick-item .slick-img{
  border-radius: 6px;
  width: 375px;
  height: 375px;
  background-color: #191919;
  position: relative;
}

.slick-item .after {
  position: absolute;
  height: 220px;
  width: 375px;
  border-radius: 6px;
  top: 385px;
  background-color: #191919;
  z-index: 2;
  opacity: 0;
  padding: 30px 20px 10px;
  color: transparent;
  font-size: 17px;
  overflow: hidden;
  text-align: center;
  -webkit-transition: opacity 0.4s ease, color 0.9s cubic-bezier(0.68, -0.55, 0.27, 1.55);
  transition: opacity 0.4s ease, color 0.9s cubic-bezier(0.68, -0.55, 0.27, 1.55);
}

.slick-active .slick-item.music-spotify .slick-img, .slick-item.music-spotify .after{
  background-color: #39b907;
  color: #000;
}

.slick-active .slick-item.music-facebook .slick-img, .slick-item.music-facebook .after{
  background-color: #5714ff;
  color: #fff;
}

.slick-active .slick-item.music-deezer .slick-img, .slick-item.music-deezer .after{
  background-color: #FFAB00;
  color: #000;
}

.slick-active .slick-item.music-TikTok .slick-img, .slick-item.music-TikTok .after{
  background-color: #000;
  color: #fff;
}

.slick-active .slick-item.music-youtube .slick-img, .slick-item.music-youtube .after{
  background-color: #CA4954;
  color: #fff;
}

.slick-active .slick-item.music-instagram .slick-img, .slick-item.music-instagram .after{
  background-color: #5714ff;
  color: #fff;
}

.slick-active .slick-item.music-apple .slick-img,.slick-item.music-apple .after{
  background-color: #000;
  color: #fff;
}

.slick-active .slick-item.music-amazon .slick-img, .slick-item.music-amazon .after{
  background-color: #FFAB00;
  color: #000;
}

.slick-active .slick-item .after{
  opacity: 1;
}

.slick-item img {
  width: 80px;
  position: absolute;
  left: calc(50% - 40px);
  top: calc(50% - 40px);
  transition: all 0.4s ease;
}

.bar {
  position: absolute;
  top: 55%;
  left: -100%;
  width: 300%;
}

.bar-container {
  height: 10px;
}

.all-need {
  font-size: 18px;
}

.tools-description .fw-extrabold {
  font-size: 2em;
  max-width: 50%;
}

.features-row {
  img {
    border-radius: 3px;
  }
}

.container{
  font-size: 16px;
  font-weight: 400;
}

.secion-basic-i .guide-block:first-child{
  padding-bottom: 80px;
  margin-bottom: 20px;
}

.secion-basic-ii{
  background-image: url('/static/img/landing/distribution/Circlesdegrade.png');
  background-position: calc(100%) 0%;
  background-size: 120px;
  background-repeat: no-repeat;
  padding-top: 60px;
  margin-top: 40px;
  position: relative;
  z-index: 5;
}

.guide-block07{
  background-position: calc(0% - 75px) 0%, calc(100% + 75px) 0%;
  background-size: 150px;
  background-repeat: no-repeat;
  padding-top: 60px;
  margin-top: 140px;
}

.guide-block01{
  position: relative;
  z-index: 55;
  &:before {
    content: "";
    position: absolute;
    top: 68px;
    left: -53px;
    background-image: url('/static/img/landing/distribution/DotsBackground.png');
    background-repeat: no-repeat;
    background-size: 150px;
    width: 150px;
    height: 200px;
  }
  h1 {
    font-size: 75px;
    font-weight: 700;
    line-height: 75px;
    margin-top: 110px;
    margin-bottom: 30px;
  }
  p {
    font-size: 16px;
    line-height: 20px !important;
    margin-bottom: 35px;
    font-weight: 200;
    max-width: 475px;
  }
}

.guide-block02{
  img{
    border-radius: 6px;
  }
  .title-idfy{
    color: transparent;
    -webkit-text-stroke: 2px white;
    font-size: 135px;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
    position: absolute;
    top: 0;
    left: calc(100% + 95px);
    font-weight: 600;
    width: 140%;
    display: block;
    letter-spacing: -3px;
    z-index: 4;
    label{
      width: 320px;
      height: 35px;
      border: 2.5px solid #fff;
      position: relative;
      top: -60px;
      margin-right: 20px;
    }
  }
  .phone {
    position: relative;
    z-index: 3;
    width: 50%;
    margin: 0 auto;
    display: block;
    margin-top: 80px;
  }
  .background {
    position: absolute;
    top: -110px;
    right: -90px;
    width: 120%;
    z-index: 2;
  }
}

.guide-block03{
  .container {
    max-width: 400px;
  }
  h2 {
    font-size: 30px;
    line-height: 35px;
    margin-bottom: 60px;
    margin-top: 60px;
    text-align: center;
  }
  p {
    font-size: 16px;
    line-height: 20px !important;
    margin-bottom: 50px;
    font-weight: 200;
    max-width: 330px;
    margin: 0 auto;
    margin-bottom: 30px;
  }
}

.guide-block04{
  position: relative;
  &:after {
    content: "";
    position: absolute;
    top: 95px;
    right: -60px;
    background-image: url('/static/img/landing/distribution/CircleBackground.png');
    background-repeat: no-repeat;
    background-size: 205px;
    width: 205px;
    height: 235px;
    z-index: 1;
  }
  h3 {
    font-size: 30px;
  }
  img {
    position: relative;
    z-index: 2;
    border-radius: 10px;
  }
  a {
    margin: 0 auto;
    display: table;
  }
  label {
    font-size: 50px !important;
    font-weight: 600;
    text-align: center;
    display: block;
    color: transparent !important;
    text-transform: uppercase;
    margin-top: -40px !important;
    position: relative;
    z-index: 2;
    text-shadow: 0px 0px 0 rgb(225,225,225), 1px 1px 0 rgb(206,206,206), 2px 2px 0 rgb(186,186,186), 3px 3px 0 rgb(166,166,166), 4px 4px 0 rgb(147,147,147), 5px 5px 0 rgb(127,127,127), 6px 6px 0 rgb(107,107,107), 7px 7px 6px rgba(0,0,0,0.85), 7px 7px 1px rgba(0,0,0,0.5), 0px 0px 6px rgba(0,0,0,.2);
  }
}

.guide-block05 {
  color: #fff;
  padding: 20px 0;
  background: rgba(255, 31, 32, 0.25);
  z-index: 1;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.guide-block05 h3 {
  display: inline-block;
  border-bottom: 3px dashed #4de8c0;
  font-weight: 700;
  margin-right: 20px;
  font-size: 28px;
  line-height: 46px;
  margin-bottom: 0;
}

.guide-block05 span {
  font-size: 28px;
  font-weight: 300;
  line-height: 40px;
}

.guide-block05 span b {
  font-weight: 700;
}

.guide-block05 a {
  float: right;
  margin-top: 2.5px;
  font-weight: 500;
}

.guide-block06{
  padding: 100px 0;
}

.blockIcon-text {
  padding-right: 60px;
}

.guide-block06 h3 {
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 30px;
}

.guide-block06 h4 {
  font-size: 21px;
  font-weight: 600;
  margin-bottom: 30px;
}
.guide-block06 p {
  font-size: 16px;
  margin-bottom: 15px;
  font-weight: 200;
  line-height: 20px;
}

.blockIcon-icon {
  font-size: 40px;
  margin-top: 70px;
  display: inline-block;
  line-height: 62px;
}

.blockIcon-icon i{
  vertical-align: initial;
  position: relative;
  top: -2px;
}

.blockIcon-icon div {
  float: left;
  border: 2px solid #fff;
  border-radius: 50%;
  height: 60px;
  width: 60px;
  text-align: center;
  margin-right: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.blockIcon-icon div:nth-child(3) {
  font-size: 35px;
  line-height: 60px;
}

.blockIcon-icon div:nth-child(5) {
  font-size: 30px;
  line-height: 60px;
}

.blockIcon-icon div.active {
    border-color: #5915ff;
}

.blockIcon-icon span {
  width: 80px;
  float: left;
  margin-top: 30px;
  border-top: 3px dashed #BDBDBD;
  margin-right: 5px;
}

.blockIcon-button {
  float: right;
  padding-top: 70px;
}

.blockIcon-button button {
  display: block;
  min-width: 286px;
  margin: 30px 0;
  font-size: 14px;
  background-color: transparent !important;
  background-image: none;
  border-color: #fff !important;
  transition: all 0.3s ease;
}

.blockIcon-button button.active {
  background-color: #5714ff !important;
  background-image: linear-gradient(to right, #5714ff, #912fff);
  border-color: #5714ff !important;
}

.container-min {
  margin: 0 auto;
  width: 100%;
  max-width: 700px;
}

.guide-block07 p {
  font-size: 60px;
  font-weight: 700;
  line-height: 65px;
}

.guide-block07 h4 {
  font-size: 22px;
  font-weight: 200;
  margin: 60px 0 40px;
}

.guide-block07 h5 {
  margin: 10px 0 10px;
}

.music-row {
  display: flex;
}

.music-know .music-col-3 {
  background-color: #191919;
  border-radius: 4px;
  margin: 4px;
  width: 175px;
  height: 175px;
  position: relative;
}

.music-know .music-col-3:hover {
  background-color: #39b907;
}

.music-know .music-col-3.music-left .after {
  position: absolute;
  height: 175px;
  left: calc(100% + 8px);
  border-radius: 4px;
  background-color: #39b907;
  z-index: 2;
  width: 0;
  opacity: 0;
  padding: 0px;
  color: transparent;
  font-size: 13px;
  overflow: hidden;
  text-align: left;
  transition: width 0.4s ease, opacity 0.4s ease, padding 0.4s ease, color 0.9s cubic-bezier(0.68, -0.55, 0.27, 1.55);
}

.music-know .music-col-3.music-right .after {
  position: absolute;
  height: 175px;
  right: calc(100% + 8px);
  border-radius: 4px;
  background-color: #39b907;
  z-index: 2;
  width: 0;
  opacity: 0;
  padding: 0px;
  color: transparent;
  font-size: 13px;
  overflow: hidden;
  text-align: left;
  transition: width 0.4s ease, opacity 0.4s ease, padding 0.4s ease, color 0.9s cubic-bezier(0.68, -0.55, 0.27, 1.55);
}

.music-know .music-col-3.music-spotify .after{
  background-color: #39b907;
}
.music-know .music-col-3.music-spotify:hover .after, .music-know .music-col-3.music-spotify:hover{
  color: #000;
  background-color: #39b907;
}

.music-know .music-col-3.music-facebook .after{
  background-color: #5714ff;
}
.music-know .music-col-3.music-facebook:hover .after, .music-know .music-col-3.music-facebook:hover{
  color: #fff;
  background-color: #5714ff;
}

.music-know .music-col-3.music-deezer .after{
  background-color: #FFAB00;
}
.music-know .music-col-3.music-deezer:hover .after, .music-know .music-col-3.music-deezer:hover{
  color: #000;
  background-color: #FFAB00;
}

.music-know .music-col-3.music-TikTok .after{
  background-color: #000;
}
.music-know .music-col-3.music-TikTok:hover .after, .music-know .music-col-3.music-TikTok:hover{
  color: #fff;
  background-color: #000;
}

.music-know .music-col-3.music-youtube .after{
  background-color: #CA4954;
}
.music-know .music-col-3.music-youtube:hover .after, .music-know .music-col-3.music-youtube:hover{
  color: #fff;
  background-color: #CA4954;
}

.music-know .music-col-3.music-instagram .after{
  background-color: #5714ff;
}
.music-know .music-col-3.music-instagram:hover .after, .music-know .music-col-3.music-instagram:hover{
  color: #fff;
  background-color: #5714ff;
}

.music-know .music-col-3.music-apple .after{
  background-color: #000;
}
.music-know .music-col-3.music-apple:hover .after, .music-know .music-col-3.music-apple:hover{
  color: #fff;
  background-color: #000;
}

.music-know .music-col-3.music-amazon .after{
  background-color: #FFAB00;
}
.music-know .music-col-3.music-amazon:hover .after, .music-know .music-col-3.music-amazon:hover{
  color: #000;
  background-color: #FFAB00;
}

.music-know .music-col-3:hover .after {
  width: calc(200% + 8px);
  opacity: 1;
  padding: 30px;
  color: #000;
}

.music-col-3.music-deezer img {
  width: 80px;
  left: calc(50% - 40px);
  top: calc(50% - 10px);
}

.slick-item.music-deezer img {
  width: 160px;
  left: calc(50% - 80px);
  top: calc(50% - 20px);
}

.music-col-3.music-deezer img:nth-child(1), .music-col-3.music-deezer:hover img:nth-child(2), .music-col-3.music-spotify img:nth-child(1), .music-col-3.music-spotify:hover img:nth-child(2) {
  opacity: 0;
  transition: opacity 0.6s ease;
}

.music-col-3.music-deezer img:nth-child(2), .music-col-3.music-deezer:hover img:nth-child(1), .music-col-3.music-spotify img:nth-child(2), .music-col-3.music-spotify:hover img:nth-child(1) {
  opacity: 1;
}

.music-deezer .slick-img img:nth-child(1), .slick-active .music-deezer .slick-img img:nth-child(2), .music-spotify .slick-img img:nth-child(1), .slick-active .music-spotify .slick-img img:nth-child(2) {
  opacity: 0;
  transition: opacity 0.6s ease;
}

.music-deezer .slick-img img:nth-child(2), .slick-active .music-deezer .slick-img img:nth-child(1), .music-spotify .slick-img img:nth-child(2), .slick-active .music-spotify .slick-img img:nth-child(1) {
  opacity: 1;
}

.music-apple img {
  border: 1px solid #fff;
  border-radius: 8px;
  background-color: #fff;
}

.music-col-3 img {
  width: 46px;
  position: absolute;
  left: calc(50% - 23px);
  top: calc(50% - 23px);
}

.guide-block07 a {
  margin-bottom: 40px;
}

.social-pro{
  background-image: url('/static/img/landing/distribution/Probadge.png');
  background-position: calc(100% - 10px) calc(0% + 10px);
  background-size: 50px;
  background-repeat: no-repeat;
}

.secion-basic-iii {
  padding: 60px 0;
}

.secion-basic-iii h2 {
  font-size: 30px;
  font-weight: 700;
}

.options-indiefy {
  margin-top: 60px;
}

.block-option {
  padding: 60px 40px 100px;
  max-width: calc(50% - 25px);
  position: relative;
  border-radius: 10px;
}

.block-free {
  margin-right: 0px;
  background-color: #F9FBFD;
  margin-left: 50px;
  color: #212529;
  .btn-primary-new {
    &:hover {
      color: #1b1d20;
    }
  }
}

.block-option h3 {
  margin-top: 30px;
  font-size: 60px;
  font-weight: 200;
}
.block-option {
  img {
    width: 35px;
    position: relative;
    left: 0px;
  }
  .title {
    display: inline-block;
    margin-left: 14px;
    font-size: 22px;
    letter-spacing: 4px;
    font-weight: 300;
    transform: translateY(4px);
  }
}

.block-option h3 b span{
  font-size: 28px;
}

.block-option h3 b label{
  color: rgb(255, 255, 255) !important;
  font-size: 22px !important;
  font-weight: 600;
}

.secion-basic-iii {
  .block-option {
    p {
      font-size: 16px;
      font-weight: 300;
      line-height: 22px;
      min-height: 66px;
    }
  }
  .block-pro {
    p {
      color: #969696;
    }
  }
}

.secion-basic-iii ul {
  margin: 50px 0;
  padding-left: 20px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  font-size: 16px;
  li {
    list-style: none;
    margin-left: -18px;
    margin-bottom: 20px;
    font-weight: 300;
    i {
      color: #969696;
      padding-right: 10px;
    }
  }
}

.block-option a {
  position: absolute;
  bottom: 78px;
  min-width: 120px;
  width: calc(100% - 80px);
}

.block-pro {
  background-color: #000;
}

.secion-basic-iii .slick-item {
  width: 600px !important;
  height: 600px;
}

.slick-item .block-option {
  max-width: 100%;
  margin: 0;
  text-align: center;
  height: 100%;
}

.secion-basic-iii .slick-slider{
  margin-top: 60px;
}

.btn-primary-new {
  background: #E22369;
  border-color:#E22369;
  color: #fff;
  transition: all .2s;
  &:hover {
    background: transparent;
  }
}
.btn-primary-new-white {
  background: #fff;
  border-color:#fff;
  color: #212529;
  transition: all .2s;
  &:hover {
    background: transparent;
    color:#fff;
  }
}

@media screen and (min-width:992px) and (max-width: 1200px) {
  .block-option h3 {
    font-size: 50px;
  }
  .guide-block02 .title-idfy label{
    width: 215px;
  }
}

@media screen and (min-width:414px) and (max-width: 992px) {
  .guide-block01{
    &:before{
      display: none;
    }
    h1{
      font-size: 60px;
      line-height: 60px;
      margin-bottom: 60px;
      margin-top: 20px;
    }
    p{
      font-size: 20px;
      line-height: 28px !important;
      margin-bottom: 90px;
      max-width: 100%;
      text-align: center;
    }
  }

  .guide-block02 .title-idfy{
    display: none;
  }
  .col-md-7, .col-md-5, .col-md-6 {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .guide-block{
    text-align: center;
  }
  .mt-5.guide-block02.col-md-5 {
    margin-top: 70px !important;
  }
  .btn-md {
    font-size: 18px;
    padding: 14px 55px;
  }
  br {
    display: none !important;
  }

  .guide-block03 h2 {
    font-size: 45px;
    line-height: 55px;
    margin-top: 0px;
  }
  .guide-block03 p {
    font-size: 16px;
    margin-bottom: 60px;
    max-width: 100%;
  }
  .guide-block03 .container {
    max-width: 100%;
    text-align: center;
  }

  .guide-block06{
    text-align: center;
  }

  .blockIcon-text {
    padding: 0 16%;
  }

  .blockIcon-icon {
    display: none;
  }

  .blockIcon-button {
    padding-top: 0px;
    float: none;
  }

  .blockIcon-button button {
    margin: 20px auto;
    padding: 14px 0px;
  }

  .block-pro {
    margin-left: 0px;
  }

  .block-free {
    margin-right: 0px;
  }

  .options-indiefy .block-option {
    max-width: 90% !important;
    margin: 10px auto;
  }

  .slick-slider{
    display: block !important;
  }

  .guide-block07 h2 {
    font-size: 45px;
    line-height: 50px;
  }

  .guide-block07 {
    padding-top: 30px;
  }

  .guide-block07 h4 {
    font-size: 30px;
    font-weight: 300;
    margin: 45px 0;
  }

  .music-know{
    display: none;
  }

  .guide-block05 h3, .guide-block05 span{
    font-size: 22px;
  }

  .block-option h3 {
    font-size: 50px;
  }

  .slick-item .block-option a {
    bottom: 40px;
    min-width: 150px;
    left: calc(50% - 75px);
  }

  .secion-basic-iii .slick-slider {
    max-height: 800px;
  }

  .block-mobile{
    display: block !important;
  }
  .block-desktop{
    display: none !important;
  }
}

@media screen and (min-width:721px) and (max-width: 992px) {
  .slick-item .block-option {
    max-width: 100%;
    margin: 0;
    text-align: center;
    height: 100%;
    padding: 60px 75px 100px;
  }

  .secion-basic-iii .slick-item {
    width: 80VW !important;
    height: 600px;
  }
}

@media screen and (min-width:601px) and (max-width: 720px) {
  .slick-item .block-option {
    max-width: 100%;
    margin: 0;
    text-align: center;
    height: 100%;
    padding: 60px 50px 100px;
  }

  .secion-basic-iii .slick-item {
    width: 80VW !important;
    height: 650px;
  }
}

@media screen and (min-width:415px) and (max-width: 600px) {
  .slick-item .block-option {
    max-width: 100%;
    margin: 0;
    text-align: center;
    height: 100%;
    padding: 60px 15px 100px;
  }

  .secion-basic-iii .slick-item {
    width: 80VW !important;
    height: 800px;
  }
}

@media screen and (min-width:415px) and (max-width: 500px) {
  .block-option h3[data-v-38374d31] {
      font-size: 35px;
  }
}

@media screen and (min-width:0px) and (max-width: 414px) {
  .guide-block{
    text-align: center;
  }
  br {
    display: none !important;
  }
  .guide-block01 h1 {
    font-size: 48px;
    line-height: 54px;
    margin-bottom: 50px;
    margin-top: 20px;
  }
  .secion-basic-i .guide-block:first-child{
    background-image: none;
  }
  .guide-block02 .title-idfy{
    display: none;
  }
  .guide-block03 .container {
    max-width: 100%;
    text-align: center;
  }
  .guide-block01::before{
    display: none;
  }
  .guide-block03 h2{
    font-size: 34px;
    line-height: 42px;
    margin-bottom: 40px;
    margin-top: 0px;
  }
  .guide-block03 p{
    font-size: 16px;
    line-height: 20px !important;
    margin-bottom: 30px;
  }
  .guide-block04 label{
    display: none;
  }
  .guide-block04 a {
    margin-top: 30px;
  }

  .guide-block04 label{
    font-size: 14px !important;
  }

  .guide-block05 {
    text-align: center;
    padding: 20px 0 35px;
  }

  .guide-block05 h3{
    display: block;
    border: none;
  }

  .guide-block05 span b{
    display: block;
  }

  .guide-block05 span{
    display: block;
  }

  .guide-block05 a {
    float: none;
    margin: auto;
    margin-top: 4px;
  }

  .guide-block06{
    text-align: center;
  }

  .blockIcon-text {
    padding: 0 5%;
  }

  .blockIcon-icon {
    display: none;
  }

  .blockIcon-button {
    padding-top: 0px;
    float: none;
  }

  .blockIcon-button button {
    margin: 20px auto;
    padding: 14px 0px;
  }

  .guide-block07 a{
    margin-top: 15px;
  }

  .guide-block07 h2 {
    font-size: 30px;
    line-height: 40px;
    margin-bottom: 50px;
  }

  .guide-block07 {
    padding-top: 30px;
  }

  .guide-block07 h4 {
    display: none;
  }

  .guide-block07 p {
    font-size: 30px;
    line-height: 40px;
    margin-bottom: 40px;
  }

  .guide-block07{
    background-image: none;
  }

  .slick-slider{
    display: block !important;
    max-height: 550px;
  }

  .music-know{
    display: none;
  }

  .options-indiefy .block-option {
    max-width: 90% !important;
    margin: 10px auto;
  }

  .slick-item {
    width: 300px !important;
    height: 595px;
    margin: 0 10px;
  }

  .slick-item .slick-img {
    width: 300px;
    height: 300px;
  }

  .slick-item .after {
    height: 220px;
    width: 300px;
    top: 310px;
    font-size: 14px;
  }

  .guide-block01 p, .guide-block03 p, .guide-block03 img{
    display: none;
  }

  .block-mobile{
    display: block !important;
  }
  .block-desktop{
    display: none !important;
  }

  .block-option h3 {
    font-size: 35px;
  }

  .slick-item .block-option {
    max-width: 100%;
    margin: 0;
    text-align: center;
    height: 100%;
    padding: 60px 25px 100px;
  }

  .secion-basic-iii .slick-item {
    width: 90VW !important;
    height: 800px;
  }

  .secion-basic-iii .slick-slider {
    max-height: 800px;
  }

  .slick-item .block-option a {
    bottom: 40px;
    min-width: 150px;
    left: calc(50% - 75px);
  }
}

@media screen and (min-width:320px) and (max-width:576px) {
  .tools-description .fw-extrabold {
    max-width: 80% !important;
  }
}
@media screen and (max-width: 767px) {
  .guide-block02 {
    .background {
      top: -80px;
      right: -30px;
      width: 120%;
    }
  }
}

.marquee-container {
  position: relative;

  a {
    color: #c8b3ff;
  }
}

.marquee-container marquee {
  padding-left: 100px;
}

.marquee-container .marquee-title {
  padding: 8px 9px;
  color: white;
  font-weight: bold;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 30%;
  z-index: 10;
}

.text-45 {
  font-size: 45px;
}

.pro-description {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/LandingDistributionGuide.vue